import React from 'react'
import { motion } from "framer-motion";
import banner from '../banner1.webp'
import StatsSection from './StatsSection';

export default function HeroBanner() {
  return (
     <section className="relative overflow-hidden bg-gr py-16 sm:py-20 lg:py-28 px-4 sm:px-6 lg:px-8 ">

        {/* Overlay Glow */}
        <div className="absolute inset-0 bg-gradient-to-br from-white/10 via-transparent to-white/10 backdrop-blur-sm"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative pt-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">

            {/* LEFT CONTENT */}
            <div className="text-center lg:text-left">

              {/* Badge */}
              {/* <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md px-4 py-2 rounded-full mb-5 border border-white/20">
                <span className="text-xs sm:text-sm text-white">
                  Trusted by 500,000+ investors worldwide
                </span>
              </div> */}

              {/* Heading */}
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4 sm:mb-6">
                STRUCTURING CAPITAL.  <br/>
                <span className="bg-gradient-to-r from-white to-emerald-300 bg-clip-text text-transparent mt-4 lg:text-5xl">
                POWERING GROWTH.
                </span>
              </h1>

              {/* Description */}
              <p className="text-sm sm:text-base md:text-lg text-white/80 mb-8 leading-relaxed pt-3">
                End-to-end financial advisory across debt, equity & structured finance.
              </p>

              {/* Buttons */}
              <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start pt-5">
                <button className="bg-dark-gold text-white px-6 py-3 rounded-lg font-medium hover:scale-105 transition">
                 Get Funding
                </button>

                 <button className="bg-dark-gold text-white px-6 py-3 rounded-lg font-medium hover:scale-105 transition">
                 Our Services
                </button>

              
              </div>
            </div>

            {/* RIGHT IMAGE */}
            <div className="flex justify-center lg:justify-end relative">
              {/* Main Image */}
              <div className="relative animate-float">
                <img  src={banner} alt="finance"  className=""/> </div>

            
            </div>

          </div>

          {/* ANIMATION */}
          <style>{`
    @keyframes float {
      0%,100% { transform: translateY(0); }
      50% { transform: translateY(-12px); }
    }
    .animate-float {
      animation: float 5s ease-in-out infinite;
    }
  `}</style>

{/* <CustomerList/> */}

<StatsSection/>

  
        </div>

      </section>
  )
}
